import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ZpDataService } from "../services/zp-data.service";
import { CustomValidators } from "../custom-validators";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";
import { PreviousUrlService } from "../services/previous-url.service";

@Component({
    selector: "app-professional-manager-home-page",
    templateUrl: "./professional-manager-home-page.component.html",
    styleUrls: ["./professional-manager-home-page.component.scss"],
    standalone: false
})
export class ProfessionalManagerHomePageComponent implements OnInit {
  public user: any;
  public refCode: string;
  public logoUrl: string;
  public professionalAccounts;
  public licenses: [];
  public submitted: boolean = false;
  public dataIsLoaded: boolean;
  public currentFile: File;
  public message: string;
  public clientSignUpLink: string =
    "Your professionals can sign up to Zenplans using this unique link.";
  public clientIntroEmail: string =
    "Email templates to help you introduce Zenplans to your clients.";
  public changeLogoTooltip: string =
    "Click the button and select a new logo to represent your company.";
  public statusResources;
  public statusTeamMembers;
  public statusClientIssues;
  public lineState = [];
  public selectedUser: any;
  public userDetail: boolean;
  public showAllUsers: boolean;
  public statusAttachments: string;
  public textCopied: boolean;
  public newArray: any;
  public totalLicenses;
  public previousLink: string;

  constructor(
    private api: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private formBuilder: FormBuilder,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    private previousUrl: PreviousUrlService
  ) {}

  updateScreen() {
    this.api.getUser().then(async (user) => {
      this.user = user;
      this.refCode = user.license.refCode;
      if (user && user.attachments) {
        let logo = user.attachments.find((a) => a.fileName == "logo");
        if (logo && user.license && user.license.refCode) {
          this.logoUrl = await this.api.getLogoUrl(user.license.refCode);
        }
      }
      if (user.attachments == undefined) {
        this.statusAttachments = "empty";
        user['statusAttachments'] = this.statusAttachments;
        this.getInfoAndPassService.getInfoAndPass(this.statusAttachments);
      }
    });
  }

  async ngOnInit() {
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log('previousLink: ', this.previousLink);
    if (this.previousLink === "/log-in" || this.previousLink === "/auth") {
      window.location.reload();
    }
    this.showAllUsers = true;
    this.updateScreen();
    this.professionalAccounts = [];
    let result = await this.api.getProfessionalAccounts().then((accounts) => {
      this.professionalAccounts = accounts;
    });
    let totalLicenses = [];
    this.professionalAccounts.forEach((licensesArray) => {
      this.licenses = licensesArray.licenses;
      let licenses = this.licenses;
      if (licenses.length >= 1) {
        for (var i = 0; i < licenses.length; i++) {
          totalLicenses.push(licenses[i]);
        }
      }
    });
    this.totalLicenses = totalLicenses.length;
  }

  onSelect(account) {
    this.showAllUsers = false;
    this.selectedUser = account;
    this.userDetail = true;
  }

  displayUserData(event) {
    console.log(event, "- User data from child component");
  }

  backFromDetailUser() {
    this.showAllUsers = true;
    this.userDetail = false;
  }

  async fileUpload(element) {
    this.dataIsLoaded = false;
    this.currentFile = await this.api.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    let result = await this.api.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    this.dataIsLoaded = true;
    if (result.success) {
      window.location.reload();
    } else {
      this.message = "Sorry, your file could not be uploaded.";
    }
  }

  copyText(val: string) {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.textCopied = true;
    setTimeout(() => {
      this.textCopied = false;
    }, 3000);
  }
}
